import { render, staticRenderFns } from "./DownloadPicture.vue?vue&type=template&id=d60f60e6&"
import script from "./DownloadPicture.vue?vue&type=script&lang=js&"
export * from "./DownloadPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports